import * as React from 'react'

import { classList } from 'react-classlist-helper'

import * as Icons from '~/client/src/shared/components/Icons'
import FileType from '~/client/src/shared/enums/FileType'

interface FileTypeIconProps {
  fileType: string
  className?: string
}

const FileTypeIcon: React.FC<FileTypeIconProps> = ({
  fileType,
  className: customClassName,
}) => {
  let IconComponent: (props: any) => JSX.Element = () => null

  switch (fileType) {
    case FileType.Image:
      IconComponent = Icons.FileImage
      break
    case FileType.Video:
      IconComponent = Icons.FileVideo
      break
    case FileType.Word:
      IconComponent = Icons.FileWord
      break
    case FileType.Excel:
      IconComponent = Icons.FileExcel
      break
    case FileType.PowerPoint:
      IconComponent = Icons.FilePowerpoint
      break
    case FileType.Pdf:
      IconComponent = Icons.FilePdf
      break
    default:
      IconComponent = Icons.FileImage
  }

  return (
    <IconComponent
      className={classList({
        'text-grey-light no-grow': true,
        [customClassName]: true,
      })}
    />
  )
}

export default FileTypeIcon
